const getAnalyticsConfig = (app) => ({
  search: {
    type: `inside-${app}-explorer-search-term`,
    category: `inside-${app}-explorer`,
    clicks: "inside-search-result-click",
    terms: "inside-search-text",
    suggestion: `inside-imagery-${app}-search-suggestion`
  },
  layers: {
    category: `inside-${app}-explorer-layer`,
    filter: `inside-${app}-explorer-filter`
  },
  metadata: {
    type: `inside-${app}-explorer-metadata`,
    category: `inside-${app}-explorer`,
  },
});

const configOutFields = {
  imagery: ["DatasetID", "AcqDateFirst", "AcqDateLast"],
  elevation: ["DatasetID", "AcqDateFirst", "AcqDateLast"],
  topographic: ["DateYear"],
};

export const getOutFields = (name) => {
  return configOutFields[name];
};

export const imageryConfig = {
  appTitle: "Imagery Explorer",
  appName: "imagery",
  orderingUrl:
    "https://insideidaho.org/assets/data/aerialimagerycollections.json",
  portalIds: {
    restricted: "a6590ece31e94570a43d77fd32e4b4c6",
    anonymous: "1a7d854380c44f0387c2fb7a0e038356",
  },
  serviceIds: {
    restricted: "b3c3531a30864ad4a64a3bbf13e1749e",
    anonymous: "e09c52ad1ee04077af56f6fbe4378483",
  },
  analytics: getAnalyticsConfig("imagery"),
  // change base url to Arcgis online
  baseUrl:
    "https://insideidaho.org/arcgis/rest/services/imagery/imagery/ImageServer",
};

export const elevationConfig = {
  appTitle: "Elevation Explorer",
  appName: "elevation",
  orderingUrl: "https://insideidaho.org/assets/data/elevationcollections.json",
  portalIds: {
    restricted: "a6590ece31e94570a43d77fd32e4b4c6",
    anonymous: "d496099e98fb4e0b9b188de07be7456e",
  },
  serviceIds: {
    restricted: "b3c3531a30864ad4a64a3bbf13e1749e",
    anonymous: "99edb711287e4b54897719f6fdc9b5ca",
  },
  portalUrl: "https://uidaho.maps.arcgis.com/",
  // change base url to Arcgis online
  baseUrl:
    "https://www.insideidaho.org/arcgis/rest/services/elevation/elevation_bedem/ImageServer",
  analytics: getAnalyticsConfig("elevation"),
};

export const topographicConfig = {
  appTitle: "Topographic Explorer",
  appName: "topographic",
  orderingUrl:
    "https://insideidaho.org/assets/data/historicaltopomapscollections.json",
  portalIds: {
    restricted: "",
    anonymous: "644b1da446484ee08ecf9a3e1a5364d2",
  },
  serviceIds: {
    restricted: "",
    anonymous: "0da5902d7d384ebdb89f4b212f3ec56b",
  },
  baseUrl:
    "https://insideidaho.org/arcgis/rest/services/historicalMaps/usgs_topo_idaho/ImageServer",
  analytics: getAnalyticsConfig("topographic"),
};

export const baseConfig = {
  esriVersion: "4.20",
  appId: "jnIVRFHvZCxnGvWn",
  zip_base_url: "https://www.northwestknowledge.net/data/download.php",
  footprintOptions:
    "&objectIds=&time=&geometryType=" +
    "esriGeometryEnvelope&inSR=&option=footprints" +
    "&spatialRel=esriSpatialRelIntersects&relationParam=&outFields=*" +
    "&returnGeometry=true&outSR=&returnIdsOnly=false&returnCountOnly=false&" +
    "pixelSize=&orderByFields=&groupByFieldsForStatistics=&outStatistics=" +
    "&returnDistinctValues=false&multidimensionalDefinition=&f=json",
  analyticsID: "UA-76328753-1",
};

const configs = {
  imagery: imageryConfig,
  elevation: elevationConfig,
  topographic: topographicConfig,
};

let config;

export const setConfig = (name) => {
  config = configs[name];
};

export const getConfig = (name) => configs[name];

export default config;
